"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {
    on,
    findIn,
    toggleClass,
    addClass
} from "@elements/dom-utils";
import Collapse from 'bootstrap/js/dist/collapse';


export function init () {

    onFind('.js-collapse-state', function (collapseArea) {
        let collapseStateDropdown = findIn('.js-collapse-state__filters', collapseArea);

        if (collapseStateDropdown) {
            let collapseState = findIn('.js-collapse-state__state-value', collapseStateDropdown);
            let collapseBtn = findIn('.js-collapse-state__btn', collapseArea);

            let collapse = Collapse.getOrCreateInstance(collapseStateDropdown);

            on('click', () => {
                collapse.toggle();
            }, collapseBtn);

            collapseStateDropdown.addEventListener('hide.bs.collapse', function () {
                collapseState.value = "false";
            });
            collapseStateDropdown.addEventListener('shown.bs.collapse', function () {
                collapseState.value = "true";
            });
        }
    });
}